<template>
  <div class="app-container">
    <div class="form-shell" v-loading="loadingFlag">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="132px"
      >
        <!-- <el-form-item prop="sign_in_instructions" label="签到说明">
                    <Tinymce style="width:100%;" :height="500" v-model="form.sign_in_instructions" ref="tinymce" />
                </el-form-item> -->
        <el-form-item prop="guidance" label="支付绑定指引">
          <Tinymce
            style="width:100%;"
            :height="500"
            v-model="form.guidance"
            ref="tinymce"
          />
        </el-form-item>
        <el-form-item prop="withdrawal_instructions" label="提现说明">
          <Tinymce
            style="width:100%;"
            :height="500"
            v-model="form.withdrawal_instructions"
            ref="tinymce"
          />
        </el-form-item>
        <el-form-item prop="lottery_instructions" label="抽奖说明">
          <Tinymce
            style="width:100%;"
            :height="500"
            v-model="form.lottery_instructions"
            ref="tinymce"
          />
        </el-form-item>
        <el-form-item label="KOC达人入驻标准" prop="entry_standards">
          <Tinymce
            style="width:100%;"
            :height="500"
            v-model="form.entry_standards"
            ref="tinymce"
          />
        </el-form-item>
        <el-form-item label="用户协议" prop="user_agreement">
          <Tinymce
            style="width:100%;"
            :height="500"
            v-model="form.user_agreement"
            ref="tinymce"
          />
        </el-form-item>
        <el-form-item label="用户隐私协议" prop="user_privacy">
          <Tinymce
            style="width:100%;"
            :height="500"
            v-model="form.user_privacy"
            ref="tinymce"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { getSet, modifySet } from "@/api/common.js";

export default {
  data: () => ({
    rules: {
      sign_in_instructions: [
        { required: true, message: "请输入签到说明", trigger: "change" },
      ],
      guidance: [
        { required: true, message: "请输入指引内容", trigger: "change" },
      ],
      withdrawal_instructions: [
        { required: true, message: "请输入提现说明", trigger: "change" },
      ],
      lottery_instructions: [
        { required: true, message: "请输入抽奖说明", trigger: "change" },
      ],
      entry_standards: [
        { required: true, message: "请输入入驻标准", trigger: "change" },
      ],
      user_agreement: [
        { required: true, message: "请输入用户协议", trigger: "change" },
      ],
      user_privacy: [
        { required: true, message: "请输入用户隐私协议", trigger: "change" },
      ],
    },
    form: {
      sign_in_instructions: "",
      guidance: "",
      withdrawal_instructions: "",
      lottery_instructions: "",
      entry_standards: "",
      user_agreement: "",
      user_privacy: "",
    },
    loadingFlag: false,
  }),
  components: { Tinymce },
  beforeMount() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.loadingFlag = true;

        const { data } = await getSet({
          prefix: "text",
          prefix2: "sign",
          system_logs_content: "基础管理-协议设置-查看",
          limit: 9999,
        });

        this.form.sign_in_instructions = data.data.find(
          (item) => item.key === "text.sign"
        ).value;
        this.form.guidance = data.data.find(
          (item) => item.key === "text.paypay"
        ).value;
        this.form.withdrawal_instructions = data.data.find(
          (item) => item.key === "text.withdrawal"
        ).value;
        this.form.lottery_instructions = data.data.find(
          (item) => item.key === "text.draw"
        ).value;
        this.form.entry_standards = data.data.find(
          (item) => item.key === "text.channels"
        ).value;
        this.form.user_agreement = data.data.find(
          (item) => item.key === "text.user"
        ).value;
        this.form.user_privacy = data.data.find(
          (item) => item.key === "text.conceal_user"
        ).value;

        this.loadingFlag = false;
      } catch (err) {
        // this.loadingFlag=false
        console.log("获取失败", err);
      }
    },
    submit() {
      this.$refs["form"].validate(async (flag) => {
        if (flag) {
          try {
            this.loadingFlag = true;
            await modifySet({
              // system_logs_content: "基础管理-协议设置-设置",
              "text.sign": {
                value: this.form.sign_in_instructions,
              },
              "text.paypay": {
                value: this.form.guidance,
              },
              "text.withdrawal": {
                value: this.form.withdrawal_instructions,
              },
              "text.draw": {
                value: this.form.lottery_instructions,
              },
              "text.channels": {
                value: this.form.entry_standards,
              },
              "text.user": {
                value: this.form.user_agreement,
              },
              "text.conceal_user": {
                value: this.form.user_privacy,
              },
            });
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getData();
          } catch (err) {
            this.loadingFlag = false;
            console.log(err);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-shell {
  max-width: 880px;
}
</style>
